<template>
  <ChatMessage role="assistant" class="chat-message-typing">
    <div class="dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </ChatMessage>
</template>

<style lang="scss" scoped>
.chat-message-typing {
  display: flex;
  justify-content: center;
  align-items: center;
}
.dots {
  display: flex;
  align-items: center;
  height: 17px;
}

.dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--chat-bubble-assistant-text-color);
  vertical-align: middle;
  opacity: 0.5;
  animation: typing 1.8s infinite ease-in-out;
  margin-right: 4px;

  &t:nth-child(1) {
    animation-delay: 200ms;
  }

  &:nth-child(2) {
    animation-delay: 300ms;
  }

  &:nth-child(3) {
    animation-delay: 400ms;
  }

  &:last-child {
    margin-right: 0;
  }
}

@keyframes typing {
  0% {
    transform: translateY(0px);
    opacity: 0.7;
  }

  28% {
    transform: translateY(-7px);
    opacity: 0.4;
  }

  44% {
    transform: translateY(0px);
    opacity: 0.2;
  }
}
</style>
